import apiClient from './client';
import { QualificationRule, LocationType, RuleOutcome } from '../types/qualificationRule';

export interface EffectiveRulesetResponse {
  success: boolean;
  data: {
    rules: QualificationRule[];
  };
}

export interface QualificationRuleResponse {
  success: boolean;
  data: QualificationRule;
}

export interface CreateRuleData {
  company_id: string | null;
  departure_type: LocationType;
  arrival_type: LocationType;
  outcome: RuleOutcome;
}

export interface UpdateRuleData {
  outcome?: RuleOutcome;
  is_active?: boolean;
}

export const qualificationRulesApi = {
  /** Fetch rules for a specific company (or global rules when companyId is null). */
  getRules: async (companyId: string | null): Promise<EffectiveRulesetResponse> => {
    const params = companyId ? `?company_id=${companyId}` : '';
    const response = await apiClient.get<EffectiveRulesetResponse>(
      `/api/qualification-rules${params}`
    );
    return response.data;
  },

  /** Fetch the merged effective ruleset for a company (global base + company overrides). */
  getEffectiveRuleset: async (companyId: string): Promise<EffectiveRulesetResponse> => {
    const response = await apiClient.get<EffectiveRulesetResponse>(
      `/api/qualification-rules/effective/${companyId}`
    );
    return response.data;
  },

  createRule: async (data: CreateRuleData): Promise<QualificationRuleResponse> => {
    const response = await apiClient.post<QualificationRuleResponse>(
      '/api/qualification-rules',
      data
    );
    return response.data;
  },

  updateRule: async (id: string, data: UpdateRuleData): Promise<QualificationRuleResponse> => {
    const response = await apiClient.patch<QualificationRuleResponse>(
      `/api/qualification-rules/${id}`,
      data
    );
    return response.data;
  },

  deleteRule: async (id: string): Promise<{ success: boolean }> => {
    const response = await apiClient.delete<{ success: boolean }>(
      `/api/qualification-rules/${id}`
    );
    return response.data;
  },
};
